import axios from 'axios';
import InputData from "../Model/InputData";
import SalarySimInputPostData from "../Model/SalarySimInputPostData";
import MapService from "./MapService";
import ResultData from "../Model/ResultData";



const SalarySimService = async (salaryparam_in: SalarySimInputPostData, url: string, lang: string, origin : string) => {
  
  var urlOrigin = "IBRUNET"
  if(origin == "INTERNAL")
  {
    urlOrigin = "IBRUNETLOCAL"
  }
  
  let posturl=url + 'SalarySim/CalcSalary?o=' + urlOrigin;

  var salarySimResult = await SalarySimResult(salaryparam_in, posturl, lang);
  return salarySimResult;
}

const SalarySimResult = async (salaryparam_out: SalarySimInputPostData, url: string, lang: string) => {

  try {
     const { data } = await axios.post<ResultData>(url, salaryparam_out,
      {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        timeout: 0,
      },
    );
    return data;
  }
  catch (error) {
    if (axios.isAxiosError(error)) {
      return error.message;
    }
    else {
      return 'An unexpected error occurred';
    }
  }
}

export default SalarySimService;